<div class="flex flex-col justify-center items-center align-middle pt-8 w-full h-full">
    <div class="flex flex-col gap-4 text-white bg-ponder-light p-8 rounded card-shadow w-[32rem] text-center">
        <div class="font-bold text-xl text-foil">
            Unauthorized
        </div>
        <div>
            Please login and/or clear your cache and refresh.
        </div>
    </div>
    <div class="grow"></div>
</div>